import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import GroupsAdd from './../../elements/phases/widget/groups_add';

class GroupsPhases extends Component {
	render() {
		return (
			<GroupsList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.fetchGroupsPhasesShow(this.props.groupsPhases.pages.current);
	}
}

class GroupsList extends Component {
	render() {
		let { groupsPhases } = this.props;
		let gu = _.find(groupsPhases.permissions, (o) => {return o==='Update'});
		let gd = _.find(groupsPhases.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{groupsPhases.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Nombre</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{_.map(groupsPhases.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{gu ? <NavLink to={`/fases/grupos/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{gd ? <button onClick={() => this._getConfirm(row.id,row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.name}</td>
									<td>
										<strong className={`has-text-${row.status.style}`}>
											{row.status.name}
										</strong>
									</td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{groupsPhases.pages.total>20 &&
				<InmPagination key="concepts-pages"
				               current={groupsPhases.pages.current}
				               total={groupsPhases.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		this.props.fetchGroupsPhasesShow(value);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el Grupo "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.groupPhaseDelete(id)
		})
	}
}

export default BaseLayout(GroupsPhases, {
	title:"Administrar procesos",
	subnav: {
		icon: 'fa-sliders',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <GroupsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/group_phases/index.jsx